import { render, staticRenderFns } from "./ProductEditBuy.vue?vue&type=template&id=60952a78"
import script from "./ProductEditBuy.vue?vue&type=script&lang=ts"
export * from "./ProductEditBuy.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditBuy.vue?vue&type=style&index=0&id=60952a78&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60952a78')) {
      api.createRecord('60952a78', component.options)
    } else {
      api.reload('60952a78', component.options)
    }
    module.hot.accept("./ProductEditBuy.vue?vue&type=template&id=60952a78", function () {
      api.rerender('60952a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditBuy.vue"
export default component.exports